import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import Checkbox from 'core/components/checkbox';

export const EXCLUSIVE_OPTION_LABEL = 'Exclusive option (three Coverage A charges waived)';
export const EXCLUSIVE_OPTION_TOOLTIP = 'Escalate to underwriting to turn off';

const noop = () => {};

/**
 * GO's Exclusive option on a migrated CFM dwelling (#36514). Only the importer sets
 * `coverages.exclusiveOption`, so staff see it as a checked, disabled checkbox and cannot add or
 * remove it here; it is not a form field, and saving leaves the stored value as it is.
 */
const ExclusiveOptionCheckbox = ({ id, xs }) => (
  <Grid item xs={xs}>
    <Checkbox
      id={id}
      data-testid="exclusive-option"
      label={EXCLUSIVE_OPTION_LABEL}
      value
      disabled
      mode="dark"
      onChange={noop}
      tooltipText={EXCLUSIVE_OPTION_TOOLTIP}
      tooltipLabel="More Info"
    />
  </Grid>
);

ExclusiveOptionCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  xs: PropTypes.number
};

ExclusiveOptionCheckbox.defaultProps = {
  xs: 6
};

export default ExclusiveOptionCheckbox;
